import { useChatReadFilter } from 'src/hooks/useChatReadFilter'
import { usePollingInterval } from 'src/hooks/usePollingInterval'
import { useUnreadMessagesQuery } from '@paintscout/api'
import type { SidebarButtonProps } from '@paintscout/ui'
import { SidebarButton } from '@paintscout/ui'
import React from 'react'
import { useQuote } from '@paintscout/react-quote'

export default function QuoteSidebarButton(props: SidebarButtonProps) {
  const { quote } = useQuote()
  const unreadMessagesQuery = useUnreadMessagesQuery({
    fetchPolicy: 'cache-and-network',
    pollInterval: usePollingInterval(props.show ? 30000 : 0),
    variables: {
      quoteId: quote._id
    }
  })

  const unreadMessages = useChatReadFilter(quote._id, unreadMessagesQuery.data?.unreadMessages ?? [])

  return <SidebarButton {...props} badgeCount={unreadMessages.length || undefined} />
}
